import React from 'react';
import HeadlineWithFocus from "../../components/HeadlineWithFocus";
import styled from 'styled-components';
import { Page, Row, Column } from 'hedron';
import ColorBar from '../../components/colorbar';
import ProfileImage from '../../assets/images/apps/bcj/logo.png';
import bcj from '../../assets/images/apps/bcj/beamcolumnjoint.png';
import typeandcheck from '../../assets/images/apps/bcj/update_plots.png';
import forcedrift from '../../assets/images/apps/bcj/forcedrift.png';
import hierarchy from '../../assets/images/apps/bcj/hierarchy.png';
import license from '../../assets/images/apps/bcj/license.png';
import Form from '../../components/contact/index.it';
import DownloadIcon from '../../assets/images/download.png';
import ScrollableAnchor from 'react-scrollable-anchor';
import ResponsiveEmbed from "react-responsive-embed";



const ImageWrapper = styled.div.attrs({

  image: props => props.image
})`
  background-image: url(${props => props.image});
  background-size: 100%;
  @media (min-width: 300px) {
    background-position: center;
    background-repeat: no-repeat;
    height: 450px;
  }
`

const DownloadIconContainer = styled.div`
	position: fixed;
	zIndex: 999;
	background-image: url(${DownloadIcon});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: center;
  @media (max-width: 299px) {
    right: 10%;
    bottom: 0%;
    width: 20%;
    height: 20%;
  }
  @media (min-width: 300px) {
    right: 10%;
    bottom: 0%;
    width: 15%;
    height: 15%;
  }
  @media (min-width: 600px) {
    right: 7%;
    bottom: 2%;
    width: 12%;
    height: 12%;
  }
  @media (min-width: 1100px) {
    right: 2%;
	  bottom: 2%;
	  width: 15%;
	  height: 15%;
	}

`

const ImgColStyle = {
  padding: '0',
};


const RowStyleEVEN = {
  background: '#F9F9F9',
};

const RowStyleODD = {
  background: '#F5F5F5',
};


const About = props => {
    return (
		<div>
			<a href="#download">
				<DownloadIconContainer />
			</a>
			<Row alignItems="center" style={RowStyleEVEN}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={ProfileImage} />
				</Column>
				<Column xs={12} sm={12} smShift={0} md={6} lg={8}>
          <h1><u style={{textDecoration: 'none', borderBottom: '10px solid #DFAB50'}}>Beam Column Joint</u></h1>
				  <h3><p>Gerarchia delle resistenze per un subassemblaggio nodo, trave, colonna. Il risultato è rappresentato in un performance domain, considerando flessione, taglio, instabilità delle barre e collasso per sfilamento</p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleODD}>
        <Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
           <ImageWrapper image={bcj} />
        </Column>
				<Column xs={12} sm={12} smShift={0} md={6} lg={8}>
                    <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #A661C2'}}>Standalone</u><br />
                    </h1>
				  <h3><p>
				  	Non hai bisogno di altro software per usarla
				  </p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleEVEN}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={typeandcheck} />
				</Column>
				<Column xs={12} sm={12} smShift={0} md={6} lg={8}>
          <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #DFAB50'}}>Ambiente "Type and Check"</u></h1>
          <h3><p>Ogni volta che imposti un parametro un grafico permette di verificarne immediatamente la correttezza</p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleODD}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={forcedrift} />
				</Column>
        <Column xs={12} sm={12} smShift={0} md={6} lg={8}>
          <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #A661C2'}}>Modalità di collasso degli elementi</u></h1>
				  <h3><p>Uno dei risultati dell'analisi è il meccanismo di collasso previsto per i singoli elementi: flessione, instabilità delle barre, taglio</p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleEVEN}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={hierarchy} />
				</Column>
				<Column xs={12} sm={12} smShift={0} md={6} lg={8}>
                    <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #DFAB50'}}>Hierarchy of strength</u></h1>
				  <h3><p>BCJ determina la gerarchia delle resistenze del sub-assembly, indicando il meccanismo di collasso dell'elemento che causa lo stato limite ultimo del sub-assembly stesso</p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleODD}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ImageWrapper image={license} />
				</Column>
        <Column xs={12} sm={12} smShift={0} md={6} lg={8}>
          <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #A661C2'}}>Licenza</u></h1>
				  <h3><p>Licenza Creative commons “Attribuzione-Non Derivati 4.0 International”</p></h3>
				</Column>
			</Row>

      <Row alignItems="center" style={RowStyleEVEN}>
				<Column xs={12} sm={12} smShift={0} md={6} lg={4}  style={ImgColStyle}>
				   <ResponsiveEmbed src='https://www.youtube.com/embed/CFeXt9F0de0' allowFullScreen />
				</Column>
        <Column xs={12} sm={12} smShift={0} md={6} lg={8}>
            <h1><u style={{textDecoration: 'none', borderBottom: '12px solid #DFAB50'}}>In azione</u></h1>
				  <h3><p>Guarda questo semplice tutorial</p></h3>
				</Column>
			</Row>

      <Row>
				<ScrollableAnchor id={'download'}>
          <Column xs={12} sm={12} smShift={0} md={10} mdShift={1} lg={8} lgShift={2}>
            <Form formName="bcjit" />
					</Column>
				</ScrollableAnchor>
      </Row>
		</div>
	)
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/BCJ/index.it.jsx